var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarchartThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1072,
    height: 723,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    viewBox: "0 0 1072 723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1072,
    height: 723,
    x: 0,
    y: 0,
    id: 0,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.2 653.5L964.8 653.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.2 534.5L964.8 534.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.2 416.5L964.8 416.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.2 297.5L964.8 297.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.2 178.5L964.8 178.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.2 60.5L964.8 60.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.2 653.5L964.8 653.5",
    fill: "none",
    stroke: "#6E7079",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 653L107.5 658",
    fill: "none",
    stroke: "#6E7079"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M321.5 653L321.5 658",
    fill: "none",
    stroke: "#6E7079"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 653L536.5 658",
    fill: "none",
    stroke: "#6E7079"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M750.5 653L750.5 658",
    fill: "none",
    stroke: "#6E7079"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M965.5 653L965.5 658",
    fill: "none",
    stroke: "#6E7079"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(99.2 653)",
    fill: "#6E7079"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(99.2 534.4)",
    fill: "#6E7079"
  }, "20"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(99.2 415.8)",
    fill: "#6E7079"
  }, "40"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(99.2 297.2)",
    fill: "#6E7079"
  }, "60"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(99.2 178.6)",
    fill: "#6E7079"
  }, "80"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(99.2 60)",
    fill: "#6E7079"
  }, "100"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    xmlSpace: "preserve",
    y: 6,
    transform: "translate(214.4 661)",
    fill: "#6E7079"
  }, "Matcha Latte"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    xmlSpace: "preserve",
    y: 6,
    transform: "translate(428.8 661)",
    fill: "#6E7079"
  }, "Milk Tea"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    xmlSpace: "preserve",
    y: 6,
    transform: "translate(643.2 661)",
    fill: "#6E7079"
  }, "Cheese Cocoa"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    xmlSpace: "preserve",
    y: 6,
    transform: "translate(857.6 661)",
    fill: "#6E7079"
  }, "Walnut Brownie"), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.856 653l48.5553 0l0 -256.769l-48.5553 0Z",
    fill: "rgb(84,112,198)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M346.256 653l48.5553 0l0 -492.783l-48.5553 0Z",
    fill: "#5470c6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M560.656 653l48.5553 0l0 -512.352l-48.5553 0Z",
    fill: "#5470c6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M775.056 653l48.5553 0l0 -429.332l-48.5553 0Z",
    fill: "#5470c6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190.1224 653l48.5553 0l0 -508.794l-48.5553 0Z",
    fill: "rgb(145,204,117)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5224 653l48.5553 0l0 -435.262l-48.5553 0Z",
    fill: "#91cc75"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M618.9224 653l48.5553 0l0 -386.636l-48.5553 0Z",
    fill: "#91cc75"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M833.3224 653l48.5553 0l0 -319.627l-48.5553 0Z",
    fill: "#91cc75"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M248.3887 653l48.5553 0l0 -555.641l-48.5553 0Z",
    fill: "rgb(250,200,88)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M462.7887 653l48.5553 0l0 -326.743l-48.5553 0Z",
    fill: "#fac858"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M677.1887 653l48.5553 0l0 -489.225l-48.5553 0Z",
    fill: "#fac858"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M891.5887 653l48.5553 0l0 -231.863l-48.5553 0Z",
    fill: "#fac858"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5l200.0859 0l0 24l-200.0859 0Z",
    transform: "translate(440.957 5)",
    fill: "rgb(0,0,0)",
    fillOpacity: 0,
    stroke: "#ccc",
    strokeWidth: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarchartThumb);
export default __webpack_public_path__ + "static/media/barchart_thumb.d760bff3c49a1cba1822516c5a8271ec.svg";
export { ForwardRef as ReactComponent };